const layout = {
  sideBar: {
    menu: {
      jobs: {
        title: 'הזמנות',
        children: {
          jobs: 'הזמנות',
        },
      },
    },
  },
};

export default layout;
